import { render, staticRenderFns } from "./wxMiniProgram.vue?vue&type=template&id=a069fee4&scoped=true"
import script from "./wxMiniProgram.vue?vue&type=script&lang=ts"
export * from "./wxMiniProgram.vue?vue&type=script&lang=ts"
import style0 from "./wxMiniProgram.vue?vue&type=style&index=0&id=a069fee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a069fee4",
  null
  
)

export default component.exports